/**
 * Created by hao.cheng on 2017/5/7.
 */
import React from 'react';
import CkPage from "../components/CkPage";
import styled from "styled-components";
import {Button} from "antd";
import Iconfont from "../components/Iconfont/Iconfont";


const AMFContent = styled.div`
    background-color: #fff;
    padding: 20px 15px;
    height:calc(100vh - 80px);
    
    display: flex;
    justify-content: center;
    flex-direction: column;
    >div{
      text-align: center;
    }
    .amf-title{
      font-size: 16px;
      color: #959595;
      margin-bottom: 20px;
    }
    .amf-icon{
      font-size: 146px;
      opacity: .7;
    }
    .amf-tools{
        >button{
          font-size: 14px;
          
        }
    }
    
`

class AvailableMembershipForbidden extends React.Component {
    state = {
        animated: ''
    };

    render() {
        const ckPageContent = <div>
            <AMFContent>
                <div className="amf-icon">
                    <Iconfont libname="ckicon" type="quanxian"/>
                </div>
                <div className="amf-title">
                    该功能需要购买会员&高级会员后使用, 在线商城购买，立即生效
                </div>
                <div className="amf-tools">
                    <Button size="large" type="primary" ghost  onClick={()=>{
                        this.props.router.push("/admin/mall/products");
                    }}>进入在线商城</Button>
                </div>
            </AMFContent>
        </div>

        return (
            <CkPage title={null} content={ckPageContent}/>
        )
    }
}

export default AvailableMembershipForbidden;


// WEBPACK FOOTER //
// ./src/containers/AvailableMembershipForbidden.jsx